/* istanbul ignore file */

// declarative file
export enum InputsLabel {
  FIRSTNAME_DISABLED = 'Aucun prénom n’a été renseigné sur mon acte de naissance',
  LASTNAME_DISABLED = 'Aucun nom n’a été renseigné sur mon acte de naissance',
}
